import { Controller } from "@hotwired/stimulus"

// Zwijanie/rozwijanie bocznych kolumn w widoku operatora czata (nowy widok):
// - lista rozmów (target "list")
// - karta klienta (target "clientPanel")
// Przyciski w nagłówku (targety "listBtn"/"clientBtn") przełączają stan, który jest
// utrwalany w localStorage, żeby przetrwał nawigację między rozmowami.
// Kolumnę chowamy klasą `!hidden` (display:none !important) — bije responsywne `md:flex`/`xl:flex`.
export default class extends Controller {
  static targets = ["list", "clientPanel", "listBtn", "clientBtn"]

  connect() {
    this._apply("list", localStorage.getItem("chatColList") === "closed")
    this._apply("client", localStorage.getItem("chatColClient") === "closed")
  }

  toggleList() { this._toggle("list") }
  toggleClient() { this._toggle("client") }

  _toggle(which) {
    const key = which === "list" ? "chatColList" : "chatColClient"
    const closed = localStorage.getItem(key) !== "closed"
    localStorage.setItem(key, closed ? "closed" : "open")
    this._apply(which, closed)
  }

  _apply(which, closed) {
    const panel = which === "list"
      ? (this.hasListTarget ? this.listTarget : null)
      : (this.hasClientPanelTarget ? this.clientPanelTarget : null)
    const btn = which === "list"
      ? (this.hasListBtnTarget ? this.listBtnTarget : null)
      : (this.hasClientBtnTarget ? this.clientBtnTarget : null)

    if (panel) panel.classList.toggle("!hidden", closed)
    if (btn) {
      btn.classList.toggle("bg-blue-50", !closed)
      btn.classList.toggle("text-blue-600", !closed)
      btn.classList.toggle("text-gray-500", closed)
    }
  }
}
